import styled from 'styled-components'
import { Row } from '@microfrontends/react-components'

export const Container = styled(Row)`
`
